import PropTypes from 'prop-types'

/**
 * @typedef {Object} devicePropType
 * @property {string}   [deviceId]        - The id of the device
 * @property {string}   [deviceLabel]     - The label of the device
 * @property {string}   [deviceName]      - The name of the device
 * @property {boolean}  [isPrimaryDevice] - Flag indicating if it's a primary or secondary device
 * @property {string}   [price]           - The price of the device
 * @property {number}   [smartBundleId]   - The smartBundleId of the device
 * @property {string}   [validFromDate]   - The date this device is valid from
 * @property {string}   [validToDate]     - The date this device is valid to
 */
export const devicePropType = PropTypes.shape({
    deviceId: PropTypes.string,
    deviceLabel: PropTypes.string,
    deviceName: PropTypes.string,
    isPrimaryDevice: PropTypes.bool,
    price: PropTypes.oneOfType([PropTypes.number, PropTypes.arrayOf(PropTypes.object)]),
    smartBundleId: PropTypes.number,
    validFromDate: PropTypes.string,
    validToDate: PropTypes.string
})
